import {getConfig} from "./config";
import {isResponsiveBreakpoint} from "./responsive";

const config = getConfig();
const adjustDynamicHeights = () => {
    [...document.querySelectorAll(".dynamic-height-child")].forEach(
        (dhChild) => (dhChild.style.height = ""),
    );
    [...document.querySelectorAll(".dynamic-height")].forEach((dhRoot) => {
        const bp =
            dhRoot.getAttribute(`data-${config.appName}-dynamic-height-bp`) ||
            "xxs";

        if (!isResponsiveBreakpoint(bp)) {
            return;
        }

        const dhChildrenHeights = [];
        const dhCols = [...dhRoot.querySelectorAll(".dynamic-height-col")];

        dhCols.forEach((dhCol) => {
            let dhChildCount = 0;
            [...dhCol.querySelectorAll(".dynamic-height-child")].forEach(
                (dhChild) => {
                    const dhChildBoundingBox = dhChild.getBoundingClientRect();
                    const dhChildHeight = dhChildBoundingBox.height;
                    const currentMaxHeight =
                        dhChildrenHeights[dhChildCount] ?? 0;
                    dhChildrenHeights[dhChildCount] = Math.max(
                        dhChildHeight,
                        currentMaxHeight,
                    );
                    ++dhChildCount;
                },
            );
        });

        dhCols.forEach((dhCol) => {
            let dhChildCount = 0;
            [...dhCol.querySelectorAll(".dynamic-height-child")].forEach(
                (dhChild) => {
                    const height = dhChildrenHeights[dhChildCount] ?? 0;
                    0 < height && (dhChild.style.height = `${height}px`);
                    ++dhChildCount;
                },
            );
        });
    });
};

const setupDynamicHeights = () => {
    adjustDynamicHeights();
    window.addEventListener("load", adjustDynamicHeights);
    window.addEventListener("resize", adjustDynamicHeights);
};

export {setupDynamicHeights};
